<template>
    <section id="contact-popup">
        <div id="container-contacts-form" class="container d-flex">
            <div class="text-align-start formHeader">
                <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo"
                    style="max-width: 2em; margin-right: .5em">

                <span style="vertical-align: middle; font-weight: 600">Contatos</span>
            </div>

            <div id="div-title">
                <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
                <h2 id="container-title">Cadastro de Contatos</h2>
            </div>

            <form action="" id="contacts-form">
                <div class="input-group">
                    <label for="contactName">Nome</label>
                    <input class="form-control" name="contactName" type="text" v-model="contact.name"
                        placeholder="Insira o nome completo do contato" required>
                </div>

                <div class="input-group">
                    <label for="contactPhone">Telefone</label>
                    <vue-tel-input id="phone-input" :inputOptions="options" defaultCountry="" mode="international"
                        v-model="contact.phone">
                    </vue-tel-input>
                </div>

                <div class="input-group">
                    <label for="contactEmail">E-mail</label>
                    <input class="form-control" name="contactEmail" type="email" v-model="contact.email"
                        placeholder="Insira o e-mail do contato" required>
                </div>

                <div class="input-group mt-2">
                    <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf" style="flex: 1">
                        <option value="cpf">CPF</option>
                        <option value="cnpj">CNPJ</option>
                    </select>

                    <input v-if="idCpf == 'cpf'" class="form-control" name="contactKey" type="text"
                        v-model="contact.unique_key" v-mask="'###.###.###-##'" placeholder="XXX.XXX.XXX-XX"
                        style="flex: 4">

                    <input v-if="idCpf == 'cnpj'" class="form-control" name="contactKey" type="text"
                        v-model="contact.unique_key" v-mask="'##.###.###/####-##'" placeholder="XX.XXX.XXX/XXXX-XX"
                        style="flex: 4">
                </div>

                <div class="input-group">
                    <label for="contactEquipe">Fila</label>
                    <select class="form-control" name="contactEquipe" id="contactEquipe" v-model="contact.equipe"
                        style="flex: 1" required>
                        <option disabled value="">Selecione uma fila</option>
                        <option v-for="item in allQueues" :key="item.id" :value="item.name">
                            {{ item.name }}
                        </option>
                    </select>
                </div>

                <div class="input-group">
                    <label for="contactConsultor">Consultor</label>
                    <select class="form-control" name="contactConsultor" id="contactConsultor"
                        v-model="contact.consultor_id" style="flex: 1" required>
                        <option disabled value="">Selecione um consultor</option>
                        <option v-for="item in consultores" :key="item.consultor_id" :value="item.consultor_id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>

                <div class="input-group">
                    <label for="flagSaveCrm" style="width: auto;">Registrar no CRM Educacional</label>
                    <select class="form-control" name="flagSaveCrm" id="flagSaveCrm" v-model="flagSaveCrm" required>
                        <option :value="false" selected>Não</option>
                        <option :value="true">Sim</option>
                    </select>
                </div>

                <div v-if="saving">
                    <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
                </div>

                <div v-else>
                    <button type="submit" class="btn btn-success" id="btn-save" form="chamadoForm"
                        @click.prevent="saveContact()"><i class="fas fa-check"></i>
                        Salvar
                    </button>
                    <button type="submit" class="btn btn-danger" id="btn-cancel" form="chamadoForm"
                        @click.prevent="resetContact()"><i class="fas fa-window-close fa-fw"></i>
                        Cancelar
                    </button>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import VueTheMask from 'vue-the-mask'
import axios from 'axios';
Vue.use(VueTheMask);

export default {
    name: "ContatosRapido",
    props: ['addWppContact'],
    data() {
        return {
            contact: {
                id: undefined,
                name: "",
                id_crm: undefined,
                consultor_id: "",
                phone: "",
                email: "",
                unique_key: "",
                equipe: "",
            },
            flagSaveCrm: false,
            allQueues: [],
            options: {
                placeholder: 'Insira o telefone',
                required: true
            },
            saving: false,
            selecutediConsulto: "",
            consultores: [],
            idCpf: "cpf",
        }
    },
    created() {
        this.resultadoLead();
        axios.get('/listQueueChat')
            .then(({ data }) => {
                this.allQueues = data;
            });

        axios.get('/getAllConsultores')
            .then(({ data }) => {
                this.consultores = data;
                const meConsultor = data.find(el => el.id == user.getId());
                if (meConsultor?.consultor_id) {
                    this.selecutediConsulto = meConsultor.consultor_id;
                    this.contact.consultor_id = meConsultor.consultor_id;
                }
            });

        axios.get(`/api/share-client-cnpj?share=${this.addWppContact.phone}`)
            .then(({ data }) => {
                if (data && data[0]) {
                    this.contact = {
                        id: data[0]?.id,
                        name: data[0]?.name,
                        phone: data[0]?.phone,
                        email: data[0]?.email,
                        unique_key: data[0]?.unique_key,
                        equipe: data[0]?.equipe,
                        consultor_id: data[0]?.consultor_id
                    }
                }
            });

        if (this.addWppContact) {
            this.contact = {
                id_crm: this.addWppContact?.id_crm,
                name: this.addWppContact?.name,
                phone: this.addWppContact?.phone,
                email: this.addWppContact?.email,
                unique_key: "",
                equipe: this.addWppContact?.queue,
                consultor_id: this.addWppContact?.consultor_id
            }

        }
    },
    methods: {
        ...mapActions(["cadastrarLead", "resultadoLead"]),
        checkForm() {
            if (!this.contact.name || this.contact.name == '') {
                Swal.fire({
                    html: 'O campo "Nome" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });

                return false;
            }

            const splitName = this.contact.name.split(" ");
            if (!splitName[1]) {
                Swal.fire({
                    html: 'O campo "Nome" deve conter o Nome e Sobrenome separados por espaço',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });

                return false;
            }

            if (!this.contact.phone || this.contact.phone == '') {
                Swal.fire({
                    html: 'O campo "Telefone" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }

            if (!this.contact.consultor_id || this.contact.consultor_id == '') {
                Swal.fire({
                    html: 'O campo "Consultor" não foi preenchido!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }

            return true;
        },
        resetContact() {
            Swal.fire({
                title: 'Deseja descartar as informações?',
                text: 'Você perderá as alterações não salvas!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: 'rgb(28,134,154)',
                confirmButtonText: 'Sim, descartar',
                cancelButtonText: 'Voltar ao formulário'
            }).then((result) => {
                if (result.value) {
                    this.contact.name = "";
                    this.contact.phone = "";
                    this.contact.unique_key = "";
                    this.contact.email = "";
                    this.contact.id = undefined;
                    this.contact.id_crm = undefined;
                    this.idCpf = "cpf";
                    this.contact.equipe = "";
                    this.$emit('closeContacts');
                }
            })
        },
        async saveContact() {
            this.contact.consultor_id = this.selecutediConsulto;
            if (!this.checkForm()) return;
            this.saving = true;
            try {
                if (!this.contact.email || this.contact.email == "") this.contact.email = `${this.formatPhone(this.contact.phone)}@nt.com.br`;
                if (this.contact.consultor_id) {
                    const selecionado = this.consultores.find(el => el.consultor_id == this.contact.consultor_id);
                    if (selecionado) this.contact.consultor = `${selecionado.extension_line}`;
                }
                const url = this.contact.id ? "/update-contacts" : "dialer/saveContact";
                const resultContact = await axios.post(url, this.contact);
                if (!resultContact) {
                    return Swal.fire({
                        type: "error",
                        title: "Erro",
                        text: "Falha ao salvar o contato na base de dados!"
                    });
                }

                console.info('> CONTATO SALVO NO BANCO COM SUCESSO!');
                if (this.flagSaveCrm) {
                    let newLead = {
                        fullname: this.contact.name,
                        cad_cpf: this.contact.unique_key,
                        cad_codigodoconsultor: this.contact.consultor_id,
                        mobilephone: this.contact.phone,
                        emailaddress1: this.contact.email,
                    }

                    if (this.contact.id_crm) newLead.id_crm = this.contact.id_crm;
                    this.cadastrarLead(newLead);
                } else {
                    this.saving = false;
                    Swal.fire({
                        type: "success",
                        title: "Feito!",
                        html: `Contato atualizado com sucesso!`
                    });
                }

                this.contact = {
                    id: undefined,
                    name: "",
                    id_crm: undefined,
                    consultor_id: "",
                    phone: "",
                    email: "",
                    unique_key: "",
                    equipe: "",
                }
            } catch (error) {
                return Swal.fire({
                    type: "error",
                    title: "Erro",
                    text: "Falha ao salvar o contato na base de dados!"
                });
            }
        },
        formatPhone(tel) {
            tel = tel.replace(/\D/g, "");
            if (tel.slice(0, 2) == "55" && tel.length > 11) return tel.slice(2);
            return tel;
        },
    },
    watch: {
        idCpf() {
            this.contact.unique_key = "";
        },
        getLead(value) {
            this.saving = false;
            if (!value || value?.Status != "Sucesso") {
                const msgErr = value ? value?.Mensagem : "Falha ao salvar o contato no CRM!";
                return Swal.fire({
                    type: "error",
                    title: "Erro",
                    text: msgErr ?? "Falha ao salvar o contato no CRM!"
                });
            }

            Swal.fire({
                type: "success",
                title: "Feito!",
                html: `Contato atualizado com sucesso!`
            });

            this.contact = {
                id: undefined,
                name: "",
                id_crm: undefined,
                consultor_id: "",
                phone: "",
                email: "",
                unique_key: "",
                equipe: "",
            }

            this.$emit('closeContacts');
        }
    },
    computed: {
        ...mapGetters(["getLead"])
    }
}
</script>

<style scoped>
#contact-popup {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 55px;
    right: 25vw;
}

.formHeader {
    background-color: rgb(28, 134, 154);
    border-top: 3px solid #f38630;
    color: white;
    padding: 0.2em;
    display: flex;
    border-radius: 20px 20px 0px 0px
}

.input-group {
    width: 90%;
    align-self: center;
    line-height: 2.55;
    display: flex;
    justify-content: space-around;
}

#container-contacts-form {
    width: 35vw;
    border: solid 2px lightgray;
    border-radius: 25px;
    text-align: center;
    flex-direction: column;
    margin: 10px;
    padding: 0;
    background-color: white;

}

#saving {
    color: rgb(28, 134, 154);
    font-size: 16px;
    text-align: center
}

#div-title {
    display: flex;
    flex-direction: column;
    margin: 20px;
}

#contacts-form {
    display: flex;
    flex-direction: column;
    text-align: center;
}

#buttonGroup {
    display: flex;
    justify-content: center;
}

#btn-save {
    border: solid 2px #008000;
    border-radius: 20px;
    background-color: #008000;
    color: white;
    transition: 0.5s
}

#btn-save:hover {
    color: #008000;
    background-color: white;

}

#btn-cancel {
    border: solid 2px #b30000;
    border-radius: 20px;
    background-color: #b30000;
    color: white;
    transition: 0.5s
}

#btn-cancel:hover {
    color: #b30000;
    background-color: white;
}

#phone-input {
    height: 2.5em;
    align-self: center;
    flex: 3;
}

section {
    display: flex;
    justify-content: center;
}

h2 {
    color: rgb(28, 134, 154)
}

label {
    margin: 10px;
    font-size: 16px;
    font-weight: 500;
}

select {
    align-self: center;
}

input {
    width: 40px;
    align-self: center;
}

button {
    width: 120px;
    margin: 20px;
    border-radius: 10px !important
}
</style>